export const filter = {
    id: null,
    name: "",
    full_name: "",
    code: "",
    status: "",
    created_at: "",
    updated_at: "",
};